/**
 * Fades and rises a section's direct content blocks into place the first
 * time the section scrolls into view. Same one-shot IntersectionObserver
 * pattern as assets/instagram-feed-grid.js and assets/pdp-media-treatment.js,
 * generalized to a section-level opt-in (blocks/section-reveal.liquid) so it
 * can cover any section without forking it - see that block's doc comment
 * for why this exists instead of porting legacy's per-element Webflow IX2
 * fades (data-w-id), which CLAUDE.md rules out.
 */
class SectionReveal extends HTMLElement {
  connectedCallback() {
    const section = document.getElementById(`shopify-section-${this.dataset.sectionId}`);
    if (!section) return;

    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      !('IntersectionObserver' in window)
    ) {
      section.classList.add('section-reveal--visible');
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            section.classList.add('section-reveal--visible');
            obs.disconnect();
          }
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(section);
  }
}

if (!customElements.get('section-reveal')) {
  customElements.define('section-reveal', SectionReveal);
}
